import { useState } from "react";

const TaskForm = ({ task, onClose, onSubmit, users }) => {
    const [title, setTitle] = useState(task ? task.title : '');
    const [assignees, setAssignees] = useState(task ? task.assignees : []);
    const [dueDate, setDueDate] = useState(task ? task.dueDate : ''); 
    const [selectedAssignee, setSelectedAssignee] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        const newTask = {
            ...task, 
            title,
            assignees,
            dueDate,
        };
        onSubmit(newTask);
    };

    const handleAddAssignee = () => {
        if (selectedAssignee && !assignees.includes(selectedAssignee)) {
            setAssignees([...assignees, selectedAssignee]);
            setSelectedAssignee('');
        }
    };

    const handleRemoveAssignee = (assigneeToRemove) => {
        setAssignees(assignees.filter(assignee => assignee !== assigneeToRemove));
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 rounded-lg p-6 w-full max-w-lg shadow-xl relative text-white">
                <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-white p-2 rounded-full hover:bg-gray-700 transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <h2 className="text-2xl font-bold mb-6">{task ? 'Edit Task' : 'Add New Task'}</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="title" className="block text-sm text-start font-medium text-gray-300 mb-1">Title</label>
                        <input
                            type="text"
                            id="title"
                            className="w-full p-2 bg-gray-700 border border-gray-600 rounded-md focus:ring-blue-500 focus:border-blue-500 outline-none"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </div>
                 
                    <div>
                        <label htmlFor="assignee" className="block text-sm text-start font-medium text-gray-300 mb-1">Assignees</label>
                        <div className="flex mb-2">
                            <select
                                id="assignee"
                                className="flex-grow p-2 bg-gray-700 border border-gray-600 rounded-l-md focus:ring-blue-500 focus:border-blue-500 outline-none"
                                value={selectedAssignee}
                                onChange={(e) => setSelectedAssignee(e.target.value)}
                            >
                                <option value="">Select Assignee</option>
                                {users.map(user => (
                                    <option key={user.id} value={user.name}>{user.name}</option>
                                ))}
                            </select>
                            <button
                                type="button"
                                onClick={handleAddAssignee}
                                className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-r-md transition-colors duration-200"
                            >
                                Add
                            </button>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {assignees.map((assignee, index) => (
                                <span key={index} className="bg-indigo-600 text-white text-xs px-2 py-1 rounded-full flex items-center">
                                    {assignee}
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveAssignee(assignee)}
                                        className="ml-1 text-white hover:text-gray-200 transition-colors"
                                    >
                                        &times;
                                    </button>
                                </span>
                            ))}
                        </div>
                    </div>
                  
                    <div>
                        <label htmlFor="dueDate" className="block text-sm text-start font-medium text-gray-300 mb-1">Due Date</label>
                        <input
                            type="date"
                            id="dueDate"
                            className="w-full p-2 bg-gray-700 border border-gray-600 rounded-md focus:ring-blue-500 focus:border-blue-500 outline-none"
                            value={dueDate}
                            onChange={(e) => setDueDate(e.target.value)}
                        />
                    </div>
                    <div className="flex justify-end space-x-3 mt-6">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md font-medium transition-colors duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium transition-colors duration-200"
                        >
                            {task ? 'Update Task' : 'Add Task'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};


export default TaskForm